import { Tooltip } from 'ui/tooltip';
import { displayDate, getFromNow, DATE_FORMAT_FULL_WITH_TIME } from 'utils/date';
import { Cell } from './ReportDataSourceTable.styled';

export const BASE_CAMPAIGN_COLUMNS = [
  {
    value: 'id',
    name: 'ID',
    RowCell: ({ row }) => <Cell>{row.id}</Cell>,
  },
  {
    value: 'name',
    name: 'Name',
    RowCell: ({ row }) => <Cell>{row.name}</Cell>,
  },
  {
    value: 'messageMedium',
    name: 'Medium',
    RowCell: ({ row }) => <Cell>{row.messageMedium}</Cell>,
  },
  {
    value: 'campaignState',
    name: 'State',
    RowCell: ({ row }) => <Cell>{row.campaignState}</Cell>,
  },
  {
    value: 'startAt',
    name: 'Launched',
    RowCell: ({ row }) => (
      <Cell>{row.startAt ? displayDate(row.startAt, DATE_FORMAT_FULL_WITH_TIME) : '-'} </Cell>
    ),
  },
];

export const BASE_WORKFLOW_COLUMNS = [
  {
    value: 'id',
    name: 'ID',
    RowCell: ({ row }) => <Cell>{row.id}</Cell>,
  },
  {
    value: 'name',
    name: 'Name',
    RowCell: ({ row }) => <Cell>{row.name}</Cell>,
  },
  {
    value: 'createdAt',
    name: 'Created',
    RowCell: ({ row }) => (
      <Cell>
        <Tooltip
          isUnderlined
          tooltipContent={displayDate(row.createdAt, DATE_FORMAT_FULL_WITH_TIME)}
        >
          {getFromNow(row.createdAt)}
        </Tooltip>
      </Cell>
    ),
  },
  {
    value: 'updatedAt',
    name: 'Updated',
    RowCell: ({ row }) => (
      <Cell>
        <Tooltip
          isUnderlined
          tooltipContent={displayDate(row.updatedAt, DATE_FORMAT_FULL_WITH_TIME)}
        >
          {getFromNow(row.updatedAt)}
        </Tooltip>
      </Cell>
    ),
  },
  {
    value: 'triggerNodeLabel',
    name: 'Trigger',
    RowCell: ({ row }) => <Cell>{row.triggerNodeLabel}</Cell>,
  },
];

export const DEFAULT_TABLE_CONFIG = {
  page: 1,
  pageSize: 10,
  orderBy: 'id',
  sortDesc: true,
  sorting: 'descending',
  filter: '',
};

export const CAMPAIGN = 'Campaign';
export const CAMPAIGNS = 'Campaigns';
export const WORKFLOW = 'Workflow';
export const WORKFLOWS = 'Workflows';
export const JOURNEYS = 'Journeys';

export const DISPLAY_NAMES = {
  [CAMPAIGN]: {
    displayName: 'campaign',
    displayNamePlural: 'campaigns',
  },
  [WORKFLOW]: {
    displayName: 'journey',
    displayNamePlural: 'journeys',
  },
};
